import { useCallback, useState } from "react";
import { useStores } from "../../components/contexts/store-provider.context";
import { Sonho } from "../../types";
import { SonhoService } from "./sonhos.service";

export function useSonho() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Sonho[]>([]);
  const [selectedData, setSelectedData] = useState<Sonho>();
  const { sonhoStore } = useStores();

  const getSonho = useCallback(async (id: string) => {
    setLoading(true);
    sonhoStore.setCrudLoading("edit", true);
    const res = await SonhoService.getSonho(id);
    if (res) {
      sonhoStore.setSelectedData(res);
      setSelectedData(res);
    }
    sonhoStore.setCrudLoading("edit", false);
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSonhos = useCallback(async () => {
    setLoading(true);
    if (!sonhoStore.data) {
      sonhoStore.setLoading(true);
    }

    const res = await SonhoService.getSonhos();

    if (res) {
      sonhoStore.set(res);
      setData(res);
    }
    sonhoStore.setLoading(false);
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteSonho = useCallback(async (data: Sonho) => {
    await SonhoService.deleteSonho(data);
    sonhoStore.removeItem((item) => item.id === data.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addSonho = useCallback(async (data: Sonho) => {
    await SonhoService.addSonho(data);
    sonhoStore.add(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateSonho = useCallback(async (data: Sonho) => {
    await SonhoService.updateSonho(data);
    sonhoStore.update(data.id || "-1", data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteImages = useCallback(async (data: string[]) => {
    await SonhoService.deleteImages(data);
  }, []);

  return {
    getSonho,
    getSonhos,
    deleteSonho,
    addSonho,
    updateSonho,
    deleteImages,
    selectedData,
    loading,
    data,
  };
}
